import { useChatModalContext } from '../contexts/chat-modal'

export const useChatModal = () => {
  const { handleOpen } = useChatModalContext()

  const openChatModal = (requestId: string, onClose?: () => void) => {
    handleOpen(requestId, onClose)
  }

  return {
    openChatModal,
  }
}
